import ControlModule            from 'scripts/poppet/control-module';
import template                 from './controlSwitchesView.jst.html';
import ControlHeatingSwitchView from './heating-switch/view-control-heating-switch-view';
import ControlAlarmSwitchView   from './main-alarm-switch/view-control-alarm-switch-view';
import { Vue }                from 'vue/defavue';

/**
 * defa.views.ControlSwitchesView
 * A control module for general home unit functionality.
 * @version 1.3.0
 */
const selectors = {
	heatingSwitch : '[data-region=heating-switch]',
	alarmSwitch   : '[data-region=alarm-switch]',
}

const ControlSwitchesView = ControlModule.extend( {
	template : template,
	expandedNavState  : 'unit:control:switches',
	compressedNavState: 'unit:control:overview',

	regions: {
		heatingSwitch   : selectors.heatingSwitch,
		alarmSwitch     : selectors.alarmSwitch,
	},

	className() {
		return this._getClassName( 'control-switches' );
	},

	onDomRefresh() {
		let self   = this;
		
		 new Vue ({
			el: '#temperatureZone',
			 data() {
				 return {
					 settingsHome: self.options.settingsHome,
					 thermostat: self.options.zoneHolderModel.getZone(1).getModel('3'),
				 }
			 },
			computed: {
				temperatureZone1 () {
					return this.thermostat.get('localTemperature') ? this.thermostat.get('localTemperature') : '';
				},
				zoneAlias (){
					return this.settingsHome.get('zone'+1).zoneAlias || 'Zone 1'
				}
			},
		});
		
		
		
		let heatingSwitchView = new ControlHeatingSwitchView( _.extend( this.options, {
			model: this.model.heatingModel,
		} ) );
		this.showChildView( 'heatingSwitch', heatingSwitchView );

		let alarmSwitchView = new ControlAlarmSwitchView( _.extend( this.options, {
			model: this.model.alarmModel,
		} ) );
		this.showChildView( 'alarmSwitch', alarmSwitchView );
	},
} );

export default ControlSwitchesView;
